/*
 * <cdx-a11y-launcher> – click-to-load placeholder for the barrierefreie-web.de plugin
 * (snippets/barrierefreiheit.liquid). The plugin script is only loaded on the first click; its own
 * launcher then takes over. "Hide forever" in the plugin is remembered (localStorage) and replaced by
 * a small "Barrierefreiheit aktivieren" button.
 */
if (!customElements.get("cdx-a11y-launcher")) {
  customElements.define(
    "cdx-a11y-launcher",
    class CdxA11yLauncher extends HTMLElement {
      static STORAGE_KEY = "kw_a11y_hidden";
      static PLUGIN_SRC = "https://barrierefreie-web.de/plugin.php";

      connectedCallback() {
        this.placeholder = this.querySelector("[data-a11y-placeholder]");
        this.reenable = this.querySelector("[data-a11y-reenable]");
        if (!this.placeholder || !this.reenable) return;

        this.abortController = new AbortController();
        const { signal } = this.abortController;
        this.placeholder.querySelector("button")?.addEventListener("click", () => this.loadPlugin(), { signal });
        this.reenable.addEventListener("click", () => this.onReenable(), { signal });

        if (this.isHidden()) this.showReenable();
        else this.showLauncher();
      }

      disconnectedCallback() {
        this.abortController?.abort();
        this.observer?.disconnect();
      }

      loadPlugin() {
        if (this.loaded) return;
        this.loaded = true;
        this.placeholder.classList.add("is-loading");

        const script = document.createElement("script");
        script.src = CdxA11yLauncher.PLUGIN_SRC;
        script.async = true;
        document.body.appendChild(script);

        // Hand over to the plugin's launcher once it exists, and remember "hide forever"
        this.observer = new MutationObserver(() => this.hookPlugin());
        this.observer.observe(document.body, { childList: true, subtree: true });
      }

      hookPlugin() {
        const trigger = document.getElementById("cx-aw-trigger");
        if (trigger && this.placeholder.isConnected) {
          this.placeholder.remove();
          setTimeout(() => trigger.click(), 50);
        }

        const hideButton = document.getElementById("cx-aw-hide-forever");
        if (hideButton && !hideButton.dataset.kwBound) {
          hideButton.dataset.kwBound = "1";
          hideButton.addEventListener("click", () => {
            this.setHidden(true);
            this.showReenable();
          });
        }
      }

      onReenable() {
        this.setHidden(false);
        // If the plugin already ran on this page, a reload gives a clean state
        if (this.loaded) window.location.reload();
        else this.showLauncher();
      }

      showLauncher() {
        this.placeholder.hidden = false;
        this.reenable.hidden = true;
      }

      showReenable() {
        this.placeholder.hidden = true;
        this.reenable.hidden = false;
      }

      isHidden() {
        try {
          return localStorage.getItem(CdxA11yLauncher.STORAGE_KEY) === "1";
        } catch (error) {
          return false;
        }
      }

      setHidden(hidden) {
        try {
          if (hidden) localStorage.setItem(CdxA11yLauncher.STORAGE_KEY, "1");
          else localStorage.removeItem(CdxA11yLauncher.STORAGE_KEY);
        } catch (error) {
          // storage unavailable – choice just isn't remembered
        }
      }
    }
  );
}
